import React from 'react';
import { Fab, FabProps, styled } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { isConversationScrolledToBottomState, isConversationScrolledToTopState } from '@tymely/atoms/scroll.atoms';
import { useAtomValue } from 'jotai';

const _Fab = styled(Fab)<{ disabled?: boolean }>`
    position: absolute;
    justify-content: center;
    left: ${({ theme }) => theme.spacing(2)};
    opacity: ${({ disabled }) => (disabled ? 0 : 1)};
    transition: opacity 150ms ease-in-out;
`;

const ScrollButton = (props: FabProps) => <_Fab size="small" color="secondary" {...props} />;

const _UpScrollButton = styled(ScrollButton)`
    top: ${({ theme }) => theme.spacing(2)};
`;

export const UpScrollButton = (props: FabProps) => {
    const isScrolledToTop = useAtomValue(isConversationScrolledToTopState);
    return (
        <_UpScrollButton {...props} disabled={isScrolledToTop}>
            <KeyboardArrowUpIcon />
        </_UpScrollButton>
    );
};

const _BottomScrollButton = styled(ScrollButton)`
    bottom: ${({ theme }) => theme.spacing(20)};
    z-index: 0;
`;

export const BottomScrollButton = (props: FabProps) => {
    const isScrolledToBottom = useAtomValue(isConversationScrolledToBottomState);
    return (
        <_BottomScrollButton {...props} disabled={isScrolledToBottom}>
            <KeyboardArrowDownIcon />
        </_BottomScrollButton>
    );
};

export default ScrollButton;
